import { useEffect } from 'react';

export const useResizeScreen = (callback: () => void) => {
  useEffect(() => {
    function updateSize() {
      callback();
    }

    window.addEventListener('resize', updateSize);

    return () => {
      window.removeEventListener('resize', updateSize);
    };
  }, [callback]);
};
